
export default function(){
    if (process.env.NODE_ENV!='production'){
        console.info.apply(null,arguments);
    }
}